import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/client/components/ui/ClientToaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/src/client/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/app/src/client/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/tailwind.css");
